import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import {
  DragDropContext,
  Draggable,
  Droppable,
  resetServerContext,
} from 'react-beautiful-dnd';
import { getOrgTermsContent } from '../../content/utils.js';
import CheckboxAdapter from '../CheckboxAdapter.jsx';
import FieldGroup from '../FieldGroup.jsx';
import { FormError } from '../FormError.jsx';
import { PortfolioInfoLink } from '../links/index.jsx';

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? 'none' : 'none',
});

const PortfolioSettingsFrom = (props) => {
  const {
    submitError,
    submitFailed,
    submitting,
    handleSubmit,
    onDragEnd,
    onCreateColumn,
    onDeleteColumn,
    onColumnNameChange,
    onContentTypeChange,
    data,
    portfolioId,
    slug,
  } = props;

  resetServerContext();

  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col xs={12}>
          <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
            <h3>{getOrgTermsContent('portfolio')} Details</h3>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xs={8}>
          <p className="communication-help text-muted m-b-24">
            {getOrgTermsContent('portfolio')} Details are the essential
            attributes of your {getOrgTermsContent('portfolio')} that provide
            clear alignment and comprehension of its purpose. You have the
            flexibility to rename, remove, and add fields according to the
            unique requirements of your {getOrgTermsContent('portfolio')}.
            Furthermore, you can rearrange the fields by utilizing the arrow
            toggle.
          </p>
        </Col>
      </Row>

      <Row className="m-b-60">
        <Col xs={12}>
          <DragDropContext onDragEnd={(result) => onDragEnd(result)}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={getListStyle(snapshot.isDraggingOver)}
                >
                  {data.length
                    ? data.map((item, index) => (
                        <Draggable
                          key={item.draggableId}
                          draggableId={item.draggableId}
                          index={index}
                        >
                          {(provided) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                            >
                              <Row>
                                <Col xs={1}>
                                  <span
                                    className="btn-move btn btn-default"
                                    {...provided.dragHandleProps}
                                  ></span>
                                </Col>
                                <Col xs={4}>
                                  <Field
                                    id={item.draggableId}
                                    name={item.draggableId}
                                    className="m-0"
                                    placeholder="Enter Title"
                                    disabled={false}
                                    type="text"
                                    label=""
                                  >
                                    {(props) => (
                                      <FieldGroup
                                        {...props}
                                        value={item.name}
                                        onChange={(event) =>
                                          onColumnNameChange(
                                            event.target.value,
                                            index
                                          )
                                        }
                                      />
                                    )}
                                  </Field>
                                </Col>
                                <Col xs={1}>
                                  <button
                                    type="button"
                                    disabled={!item.allow_delete}
                                    className="btn-delete btn btn-default"
                                    onClick={() =>
                                      onDeleteColumn(item.draggableId)
                                    }
                                  ></button>
                                </Col>
                                <Col xs={3}>
                                  <Field
                                    name={`${item.draggableId}IsEditor`}
                                    label="Rich Text Editor Field"
                                    type="checkbox"
                                    component={CheckboxAdapter}
                                    checked={item.editor}
                                    disabled={!item.allow_editor}
                                    onClick={() => onContentTypeChange(index)}
                                  />
                                </Col>
                              </Row>
                            </div>
                          )}
                        </Draggable>
                      ))
                    : null}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </Col>
        <Col xs={12}>
          <button
            disabled={data.length && !data[data.length - 1].name}
            className="btn-link"
            onClick={(event) => onCreateColumn()}
          >
            {' '}
            + Create New Column
          </button>
        </Col>
      </Row>

      <Row className="m-b-48">
        {submitFailed && submitError ? (
          <FormError submitError={submitError} />
        ) : null}
        <Col xs={12}>
          <div className="flex">
            <div>
              <PortfolioInfoLink portfolioId={portfolioId}>
                <Button bsStyle="default">Cancel</Button>
              </PortfolioInfoLink>
              <Button
                className="m-l-12"
                bsStyle="primary"
                disabled={submitting}
                type="submit"
              >
                {submitting ? 'Saving...' : 'Save'}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </form>
  );
};

export default PortfolioSettingsFrom;
